/**
 * Open Shopify Inbox / <shopify-chat> from custom links (footer "Chat Now", menu Chat, etc.)
 * Upload to: assets/open-shopify-chat.js
 * Include once in theme.liquid before </body>:
 *   <script src="{{ 'open-shopify-chat.js' | asset_url }}" defer></script>
 */
(function () {
  function getChatHost() {
    return (
      document.querySelector('shopify-chat') ||
      document.querySelector('#ShopifyChat') ||
      document.querySelector('inbox-online-store-chat')
    );
  }

  function openShopifyChat() {
    var chat = getChatHost();
    if (!chat) return false;

    if (typeof chat.show === 'function') {
      chat.show();
      return true;
    }

    try {
      var root = chat.shadowRoot;
      if (root) {
        var btn =
          root.querySelector('button[aria-controls]') ||
          root.querySelector('.chat-app > button') ||
          root.querySelector('button.chat-toggle') ||
          root.querySelector('button');
        if (btn) {
          btn.click();
          return true;
        }

        var nested = root.querySelector('shopify-agent-runtime');
        if (nested && nested.shadowRoot) {
          var nestedBtn =
            nested.shadowRoot.querySelector('button[aria-controls]') ||
            nested.shadowRoot.querySelector('button.chat-toggle') ||
            nested.shadowRoot.querySelector('button');
          if (nestedBtn) {
            nestedBtn.click();
            return true;
          }
        }
      }
    } catch (err) {
      /* ignore */
    }

    if (chat.contentWindow && chat.contentWindow.document) {
      try {
        var iframeBtn =
          chat.contentWindow.document.querySelector('button.chat-toggle') ||
          chat.contentWindow.document.querySelector('[aria-controls="chat-ui"]');
        if (iframeBtn) {
          iframeBtn.click();
          return true;
        }
      } catch (err2) {
        /* ignore */
      }
    }

    return false;
  }

  function enhanceFooterChatNow() {
    var nodes = document.querySelectorAll('.site-footer p, .footer-feature-item p');
    nodes.forEach(function (p) {
      if (!p.textContent || p.textContent.indexOf('Chat Now') === -1) return;
      if (p.querySelector('[data-open-shopify-chat]')) return;

      p.innerHTML = p.innerHTML.replace(
        /(Chat Now)/i,
        '<a href="#chat" data-open-shopify-chat class="ol-open-chat-link">$1</a>'
      );
    });
  }

  function enhanceDrawerChat() {
    document.querySelectorAll('.ud-help-cta').forEach(function (a) {
      if (a.getAttribute('data-open-shopify-chat') === '1') return;
      var label = (a.textContent || '').trim().toLowerCase();
      if (label !== 'chat') return;
      a.setAttribute('href', '#chat');
      a.setAttribute('data-open-shopify-chat', '1');
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target.closest(
        '[data-open-shopify-chat], a[href="#chat"], a[href="#live-chat"], a[href="/?chat"], a[href="?chat"]'
      );
      if (!target) return;
      e.preventDefault();
      openShopifyChat();
    },
    true
  );

  function injectLinkStyles() {
    if (document.getElementById('ol-open-chat-style')) return;
    var style = document.createElement('style');
    style.id = 'ol-open-chat-style';
    style.textContent =
      '.ol-open-chat-link{color:inherit;text-decoration:underline;text-underline-offset:2px;cursor:pointer;}' +
      '.ol-open-chat-link:hover{opacity:0.85;}';
    document.head.appendChild(style);
  }

  function shouldHideChatBubble() {
    var body = document.body;
    if (!body) return false;

    // Cart drawer/modal open — hide on mobile + desktop
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && cartDrawer.classList.contains('drawer--is-open')) {
      return true;
    }

    // PDP — mobile only
    var isProduct =
      body.classList.contains('template-product') ||
      body.hasAttribute('data-product-page') ||
      document.documentElement.hasAttribute('data-product-page');
    if (isProduct && window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
      return true;
    }
    return false;
  }

  function applyChatBubbleVisibility() {
    var hide = shouldHideChatBubble();
    var nodes = document.querySelectorAll(
      'shopify-chat, #ShopifyChat, inbox-online-store-chat'
    );
    nodes.forEach(function (el) {
      if (hide) {
        el.setAttribute('hidden', '');
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
      } else {
        el.removeAttribute('hidden');
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('pointer-events');
        el.style.removeProperty('opacity');
      }
    });
  }

  function init() {
    injectLinkStyles();
    enhanceFooterChatNow();
    enhanceDrawerChat();
    applyChatBubbleVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Inbox can inject late — re-run enhancers once after short delay
  setTimeout(init, 1200);
  setTimeout(applyChatBubbleVisibility, 2500);
  setTimeout(applyChatBubbleVisibility, 5000);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      applyChatBubbleVisibility();
    });
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width: 768px)');
    var onMq = function () {
      applyChatBubbleVisibility();
    };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }
})();